import { render, staticRenderFns } from "./cabs-goa-airport.vue?vue&type=template&id=39221b2a&scoped=true"
import script from "./cabs-goa-airport.vue?vue&type=script&lang=js"
export * from "./cabs-goa-airport.vue?vue&type=script&lang=js"
import style0 from "./cabs-goa-airport.vue?vue&type=style&index=0&id=39221b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39221b2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
